import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DraftValidationModule } from '@classifieds-sell/shared';
import { DraftFacade } from '@classifieds-sell/state';
import { TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import { TgGridModule, TgInputModule } from '@trademe/tangram';
import { MotorsDescriptionAndPhotosDescriptionSectionComponent } from './motors-description-and-photos-description-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgGridModule,
        TgInputModule,
        LayoutModule,
        TrademeCoreUiModule,
        DraftValidationModule
    ],
    declarations: [MotorsDescriptionAndPhotosDescriptionSectionComponent],
    providers: [DraftFacade],
    exports: [MotorsDescriptionAndPhotosDescriptionSectionComponent]
})
export class MotorsDescriptionAndPhotosDescriptionSectionModule {}
